/**
 * @file m站 取消订单
 */

import React, {Component} from 'react';
import {NavBar, Toast, Button, Radio, Flex, Icon} from 'antd-mobile';
import NavBarComponent from '../../component/common/NavBarComponent'
import {parseSearchToState} from '../../util/util.js';
import {Http, urls} from '../../api/index';
import './cancelOrder.scss';

const RadioItem = Radio.RadioItem;

class CancelOrder extends Component {
    constructor() {
        super();
        this.state = {
            cancelFlag: false,
            orderId: 0,
            textArray:[],
            cancelReasonId: null,
            pageList: [
                {
                    text: "取消规则",
                    url: "/commonProblem",
                    thumb: "../../assets/question.png",
                    ispage: true,
                    datas: "https://h5.izuche.com/h5/cancel.html",
                }
            ]
        };
    }

    componentDidMount() {
        const {history} = this.props;
        const search = history.location.search;
        let cancelOrderParams = parseSearchToState(search);
        this.setState({
            orderId: cancelOrderParams.id
        });
        setTimeout(() => {
            this.getReason();
        }, 0);
    }

    getReason() {
        let url = urls.cancelReason;
        let data = {orderNo: this.state.orderId};
        Http.post({url, data}).then(res => {
            this.setState({
                textArray: res.data.options
            })
        })
    }
    
    select(value) {
        this.setState({
            cancelReasonId: value
        })
    }

    submit() {
        if(!this.state.cancelReasonId){
            return Toast.info('请选择原因');
        }
        if (this.state.cancelFlag) {
            return false
        }
        let url = urls.byCustomer;
        let data = {
            orderNo: this.state.orderId,
            cancelReasonId: this.state.cancelReasonId
        }
        this.setState({
            cancelFlag: true
        })
        Http.post({url, data}).then(res => {
            Toast.info('取消成功', 2, () => {
                const {history} = this.props;
                history.go(-2)
            });
        })
    }

    goRule(item){
        const { ispage, url, datas, text } = item
        const {history} = this.props
        if (!!ispage) {
            this.props.history.push({
                pathname: '/webview',
                query: { url:datas, title:text }
            })
        } else {
            history.push({
                pathname: url
            })
        }
    }

    render() {
        return (
            <div id="cancelOrder" className="page">
                <NavBarComponent>
                    <NavBar 
                      icon={<Icon type="left" color='#333' />} 
                      onLeftClick={() => {this.props.history.goBack()}}
                      mode='light'>取消订单</NavBar>
                </NavBarComponent>
                <div className="card h-shadow">
                    {this.state.textArray.map(i => (
                        <Flex key={i.value} onClick={() => this.select(i.value)}>
                            <Flex.Item style={{ padding: '6px 0', color: '#888', flex: 'none' }}>
                                <Radio className="my-radio" checked={this.state.cancelReasonId === i.value}>
                                    <span className="label">{i.text}</span>
                                </Radio>
                            </Flex.Item>
                        </Flex>
                    ))}
                    <div className="tip">
                        <span className="red">取消订单可能产生扣费，具体可查看</span>
                        <span onClick={() => {this.goRule(this.state.pageList[0])}} className="blue">规则说明</span>
                    </div>
                    <Button className="mt20 mb5" disabled={this.state.cancelFlag} onClick={() => {this.submit()}} size="default" type="warning">提交</Button>
                </div>
            </div>
        );
    }
}

export default CancelOrder;
